'use client';

import { Fragment } from 'react';

import { FundingModel, FundingType } from '@bytel/leviator';
import {
    DirectionEnum,
    FlexBox,
    FlexItem,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyColor,
} from '@bytel/trilogy-react';

import { FundingDetailsBox } from '@components/funding-details-box';

import { FundingOptionItem } from './funding-option-item';

export interface FundingTypeSelectorProps {
    value: FundingType | null;
    onChange: (key: FundingType) => void;
    options: FundingModel[];
    fundingKeysByType: { [key in FundingType]?: FundingModel[] };
    error?: string;
    hasOdr: boolean;
    odrRefund: number;
    phonePriceWithOdrDeducted: number;
    hasMultipleInstallments: boolean;
}

export function FundingTypeSelector({
    value,
    options,
    onChange,
    error,
    fundingKeysByType,
    hasOdr,
    odrRefund,
    phonePriceWithOdrDeducted,
    hasMultipleInstallments,
}: Readonly<FundingTypeSelectorProps>) {
    return (
        <FlexItem>
            <Title level={TitleLevels.FIVE}>Sélectionnez votre paiement&nbsp;:</Title>
            <FlexBox direction={DirectionEnum.COLUMN} gap={4} mobile data-has-error={Boolean(error)}>
                {options.map((funding) => (
                    <Fragment key={funding.type}>
                        <FundingOptionItem
                            funding={funding}
                            fundingOptions={fundingKeysByType[funding.type] ?? []}
                            isSelected={value === funding.type}
                            onSelect={() => onChange(funding.type)}
                            hasOdr={hasOdr}
                            odrRefund={odrRefund}
                            phonePriceWithOdrDeducted={phonePriceWithOdrDeducted}
                        />
                        {value === funding.type &&
                            (funding.isType(FundingType.SWAPPY) || funding.isType(FundingType.YOUNITED)) &&
                            !hasMultipleInstallments && <FundingDetailsBox funding={funding} />}
                    </Fragment>
                ))}
            </FlexBox>
            {error && (
                <Text level={TextLevels.THREE} typo={TypographyColor.TEXT_ERROR}>
                    {error}
                </Text>
            )}
        </FlexItem>
    );
}
